import {
  defaultResource,
  resourceFromAttributes,
} from "@opentelemetry/resources";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import {
  WebTracerProvider,
  StackContextManager,
} from "@opentelemetry/sdk-trace-web";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";

import { LocalStorageExporter } from "./LocalStorageExporter";

const resource = defaultResource().merge(
  resourceFromAttributes({
    [ATTR_SERVICE_NAME]: "superblocks",
  }),
);

const provider = new WebTracerProvider({
  resource: resource,
  spanProcessors: [new BatchSpanProcessor(new LocalStorageExporter())],
});

/*
TODO: When we have our own trace intake
add another BatchSpanProcessor(new OTLPTraceExporter({...})) to spanProcessors above.
*/

provider.register({
  contextManager: new StackContextManager().enable(),
});
